import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Box, Typography } from '@kc-console/common-ui';
import { type ServiceMeta } from '@kc-console/context';
import { SpriteImgIcon } from '@kc-console/shared-ui';

import { getServiceDisplayName } from '../../../utils';
import ServiceBadgeList from '../MegaMenu/Content/ServiceBadgeList';

interface Props {
  /** LNB 영역 > 접힘 여부 */
  collapsed: boolean;
  /** 서비스 정보 */
  service: Pick<ServiceMeta, 'name' | 'keyword' | 'badges'> | null;
}

type ContainerProps = { collapsed?: boolean };

export default function LnbServiceTitle({ service, collapsed = false }: Props) {
  const { name = '', keyword = '', badges = [] } = service || {};
  const displayName = getServiceDisplayName(keyword, name);
  const targetBadge = badges.length > 0 ? [badges[0]] : [];
  if (!name) return null;

  return (
    <Container collapsed={collapsed}>
      <SpriteImgIcon fontSize={24} id={keyword} category={'BeyondServiceRegular'} />
      {!collapsed ? (
        <>
          <ServiceTitle variant="label/medium/xl">{displayName}</ServiceTitle>
          <ServiceBadgeList badges={targetBadge} />
        </>
      ) : null}
    </Container>
  );
}

const ServiceTitle = styled(Typography)`
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  color: ${({ theme }) => theme.color['text/default']};
`;

const Container = styled(Box, {
  shouldForwardProp: prop => prop !== 'collapsed',
})<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 64px;
  padding: 8px 20px 0;

  transition: 200ms;

  ${({ collapsed }) =>
    collapsed &&
    css`
      padding: 8px 16px 0;
    `}
`;
